import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import './Result.css'
import { DataContext } from '../../Contexts/ResultContext';
import { useAsyncError, useLocation, useNavigate } from 'react-router-dom';
import Counter from '../../Components/Counter/Counter';
import Header from '../../Components/Header/Header';


function Result() {

    const [data , setData] = useState([])
    const [correct , setCorrect] = useState(0);
    const [incorrect , setIncorrect] = useState(0);
    const [no_answer , setNo_answer] = useState(0);
    const [percent_no_manfi , setPercent_no_manfi] = useState(0);
    const [percent , setPercent] = useState(0);


    const navigate = useNavigate()
    const location = useLocation()

    const [finalTheme , setFinalTheme] = useState('');


  const finalThemeHandler = (theme) => {
    setFinalTheme(theme)
  }


    useEffect(() => {
      const {defaultTheme} = location.state;
      setFinalTheme(defaultTheme)

    } , [])

    
    useEffect(() => {
        let { data } = location.state
        setData(data)
       
        let count_correct = 0;
        let count_incorrect = 0;
        let count_no_answer = 0; 

        data.map((item) => {
            if(item.user_key == 0)
            {
                ++count_no_answer;
            } 
            else if(item.key == item.user_key)
            {
                ++count_correct;
            }
            else if(item.key != item.user_key)
            {
                ++count_incorrect;
            }
        })

        setCorrect(count_correct);
        setIncorrect(count_incorrect);
        setNo_answer(count_no_answer);

        let cal_percent_no_manfi = Math.floor((count_correct/data.length) * 100);
        let cal_percent = ((((3 * count_correct) - (count_incorrect))/(data.length * 3)) * 100).toFixed(2);
        setPercent_no_manfi(cal_percent_no_manfi)
        setPercent(cal_percent)

    } , [])


    const {defaultTheme} = location.state;

    

  return (
    <>
     <Header defaultTheme={defaultTheme} finalThemeHandler={finalThemeHandler}></Header>

<div className="content">

    
    

  <div className="percent_result">
    <div className="percent_result__percent">
    <span style={{direction : 'ltr'}}>
        { (percent > 0) ? (
          <Counter count={percent} />
        ) : (
          percent
        )}
      </span>
      <span className="percent_result__percent__symbol">%</span>
    </div>
    <div className="percent_result__text">درصد با احتساب نمره منفی</div>
  </div>

  <ul className="list">
    <li>
      <span className="list__item_key">درصد بدون احتساب نمره منفی : </span>
      <span className="list__item_value"><Counter count={percent_no_manfi} />%</span>
    </li>
    <li>
      <span className="list__item_key">تعداد سوالات درست :</span>
      <span className="list__item_value list__item_value_correct">{ correct }</span>
    </li>
    <li>
      <span className="list__item_key">نعداد سوالات نادرست :</span>
      <span className="list__item_value list__item_value_incorrect">{ incorrect }</span>
    </li>
    <li>
      <span className="list__item_key">تعداد سوالات نزده :</span>
      <span className="list__item_value">{ no_answer }</span>
    </li>

    <button className="btn-info btn-info-full" onClick={() => { navigate('/answer' , {
      state : {
        data,
        defaultTheme : finalTheme
      }
    })}}>مشاهده پاسخنامه</button>
  </ul>
</div>
    </>
  );
}

export default Result;
